import * as yup from "yup";
import { validarMoedaReal } from "../../core/utils/validarMoedaReal";

export const saborSchema = yup.object().shape({
    descricao: yup.string().required('O nome é obrigatório').max(100, "O nome não pode ter mais de 100 caracteres"),
    preco: yup.string().test('preco', 'Valor inválido', (valor) => {
        return !validarMoedaReal(valor, 0.00, undefined, true);
    }),
    precoSemDesconto: yup.string().test('precoSemDesconto', 'Valor inválido', (valor) => {
        return !validarMoedaReal(valor, 0.00, undefined, false);
    }),
    detalhes: yup.string().max(720, "A descrição não pode ter mais de 720 caracteres"),
});